import React, { useState } from 'react';
import Prompt from './SecurityManagementComponents/Prompt';

const SecurityManagement = () => {
    const [restrictedWords, setRestrictedWords] = useState<string[]>(['example', 'test']);

    const handleUpdateRestrictedWords = (words: string[]) => {
        setRestrictedWords(words);
        // You can add any additional logic needed when updating the restricted words here
    };

    return (
        <div className="mx-auto w-full max-w-screen-lg divide-y divide-gray-200 rounded-xl bg-white p-2">
            <Prompt
                restrictedWords={restrictedWords}
                handleUpdateRestrictedWords={handleUpdateRestrictedWords}
            />
        </div>
    );
};

export default SecurityManagement;
